import { type NexusApiActionDef } from "./action-def.types";
import { deleteOutput, listOutput, obj, str } from "./output-format.builders";

export const documentActions: NexusApiActionDef[] = [
  {
    action: "documents.list",
    label: "List Documents",
    description: "List documents in the organization",
    inputSchema: {
      search: { type: "string", description: "Search filter (optional)" },
      type: { type: "string", description: "Document type filter (optional)" },
      limit: { type: "number", description: "Max results (optional)" }
    },
    outputFormat: listOutput("documents")
  },
  {
    action: "documents.get",
    label: "Get Document",
    description: "Get document details",
    inputSchema: {
      documentId: { type: "string", description: "Document ID" }
    },
    outputFormat: obj("Document details")
  },
  {
    action: "documents.createText",
    label: "Create Text Document",
    description: "Create a new text document",
    inputSchema: {
      name: { type: "string", description: "Document name" },
      description: { type: "string", description: "Document description (optional)" }
    },
    outputFormat: obj("Created document")
  },
  {
    action: "documents.addWebsite",
    label: "Add Website",
    description: "Add a website as a document",
    inputSchema: {
      url: { type: "string", description: "Website URL" },
      name: { type: "string", description: "Document name (optional)" },
      crawlDepth: { type: "number", description: "Crawl depth (optional, default 0)" }
    },
    outputFormat: obj("Created website document")
  },
  {
    action: "documents.update",
    label: "Update Document",
    description: "Update document metadata",
    inputSchema: {
      documentId: { type: "string", description: "Document ID" },
      name: { type: "string", description: "New name (optional)" },
      description: { type: "string", description: "New description (optional)" }
    },
    outputFormat: obj("Updated document")
  },
  {
    action: "documents.delete",
    label: "Delete Document",
    description: "Delete a document",
    inputSchema: {
      documentId: { type: "string", description: "Document ID" }
    },
    outputFormat: deleteOutput
  },
  {
    action: "documents.getDownloadUrl",
    label: "Get Download URL",
    description: "Get the download URL for a document",
    inputSchema: {
      documentId: { type: "string", description: "Document ID" }
    },
    outputFormat: obj("Download info", {
      id: str("Document ID"),
      downloadUrl: str("Download URL")
    })
  },
  {
    action: "documents.reprocess",
    label: "Reprocess Document",
    description: "Reprocess a document",
    inputSchema: {
      documentId: { type: "string", description: "Document ID" }
    },
    outputFormat: obj("Reprocess result")
  },
  {
    action: "documents.createFolder",
    label: "Create Folder",
    description: "Create a document folder",
    inputSchema: {
      name: { type: "string", description: "Folder name" },
      parentId: { type: "string", description: "Parent folder ID (optional)" }
    },
    outputFormat: obj("Created folder")
  }
];
